(ns manage.adset-decision-tree-page.ad-variant-table-ocp.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium"
             :refer [DataGridPremium useGridApiContext]]
            ["src/svg/inform/error-triangle-fill.svg$default"
             :as AlertIcon]
            [cljs-bean.core :refer [->clj]]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.cm360-settings :as cm360.q]
            [common.validators.core :as validators]
            [common.widgets.data-grid :as dg]
            [manage.adset-decision-tree-page.ad-variant-table-ocp.cm360-settings
             :as cm360-settings]
            [manage.adset-decision-tree-page.ad-variant-table-ocp.columns :as cols]
            [manage.adset-decision-tree-page.ad-variant-table-ocp.hook :as hook]
            [manage.adset-decision-tree-page.property :as property]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.view.side-panel.editors
             :refer [inherited-adornment]]
            [manage.adset-decision-tree-page.view.tracker-table
             :refer [filter-menu use-filters]]
            [manage.adset.hooks :as ah]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ^:memo value-cell
  [{:keys [read-only edit-cell? idx type show-errors]
    {:keys [id value field hasFocus]} :params}]
  (let [api (useGridApiContext)
        {:keys [setEditCellValue startCellEditMode]} (:current (->clj api))
        [local-value set-local-value] (uix/use-state nil)
        [has-on-blur set-has-on-blur] (uix/use-state false)
        handle-change (fn [new-value]
                        (set-local-value new-value)
                        (setEditCellValue #js {:id id :field field
                                               :value new-value
                                               :debounceMs 200}))
        inherited-node-data (use-subscribe [::sub/root-node-data])
        tracker-type? (#{"click" "impression"} type)
        inherited-value (cond
                          (= type "tagging")
                          (let [tagging (get-in inherited-node-data property/tagging-data-path)]
                            (hook/tagging->str tagging))
                          tracker-type?
                          (get-in (filterv #(= type (:type %))
                                           (get-in inherited-node-data property/trackers-data-path))
                                  [(or idx 0) :value]))
        input-value (if edit-cell? local-value value)
        error (when (and (or has-on-blur show-errors) tracker-type? (seq input-value)
                         (not (validators/url? input-value)))
                "should be a URL")]
    (uix/use-effect (fn [] (set-local-value value)) [value])
    ($ TextField
       {:value (or input-value "")
        :placeholder (or inherited-value (cols/column-placeholder type))
        :slotProps #js {:input #js {:endAdornment
                                    (if (some? inherited-value)
                                      ($ inherited-adornment
                                         {:inherited-value inherited-value
                                          :node-data inherited-node-data
                                          :value (when-not read-only input-value)
                                          :set-value handle-change})
                                      (when (and (not read-only) (some? input-value) (not= type "cm360"))
                                        ($ IconButton {:on-click #(handle-change nil)}
                                           ($ Icon "clear"))))
                                    :readOnly (boolean (not edit-cell?))}}
        :size "small"
        :error (boolean error)
        :helperText error
        :fullWidth true
        :autoFocus hasFocus
        :sx #js {:px (when edit-cell? 2)}
        :variant "outlined"
        :onChange (when edit-cell? (fn [^js e] (handle-change (.. e -target -value))))
        :onClick (when (and (not edit-cell?) (not read-only))
                   (fn [^js e]
                     (.stopPropagation e)
                     (startCellEditMode #js {:id id :field field})))
        :onBlur #(set-has-on-blur true)})))

(defn- render-display-cell [details ^js params]
  ($ value-cell (merge details {:params (->clj params)})))

(defn- render-edit-cell [details ^js params]
  ($ value-cell (merge details {:params (->clj params) :edit-cell? true})))

(defui value-column-header [{:keys [type on-delete field idx read-only]}]
  ($ Stack {:direction "row"
            :alignItems "center"
            :sx #js {:minWidth 0 :width "100%"
                     "& .delete-icon" #js {:display "none"}
                     "&:hover .delete-icon" #js {:display "block"}}}
     ($ Typography {:noWrap true}
        (if (= type "impression")
          (str "Impression trackers" (when (pos? idx) (str " (" (inc idx) ")")))
          (cols/fixed-column-headers field)))
     (when-not read-only
       ($ IconButton {:size "small"
                      :className "delete-icon"
                      :onClick (fn [^js e] (.stopPropagation e) (on-delete field))
                      :sx #js {:p 0.5}}
          ($ Icon "delete")))))

(defn- value-column [{:keys [field read-only] :as details}]
  {:field field
   :flex 2
   :minWidth 200
   :editable (not read-only)
   :sortable false
   :disableColumnMenu true
   :renderCell (partial render-display-cell details)
   :renderEditCell (partial render-edit-cell details)
   :renderHeader (fn [^js _] ($ value-column-header details))})

(defn- build-value-columns [columns delete-column show-errors read-only]
  (let [imp-cols (cols/impression-columns columns)
        fixed-cols (remove cols/impression-field? columns)]
    (-> (vec (map-indexed (fn [idx field]
                            (value-column {:idx idx :field field :type "impression"
                                           :on-delete delete-column :show-errors show-errors
                                           :read-only read-only}))
                          imp-cols))
        (into (map (fn [field]
                     (value-column {:field field :type (cols/field->column-type field)
                                    :on-delete delete-column :show-errors show-errors
                                    :read-only read-only}))
                   fixed-cols)))))

(def ^:private content-id-column
  {:field "adVariant" :headerName "Content ID" :flex 2 :minWidth 150 :disableColumnMenu true})

(def ^:private decision-path-column
  {:field "decisionPath" :headerName "Decision Path" :flex 3 :minWidth 200 :disableColumnMenu true})

(def ^:private dimensions-column
  {:field "dimensions" :headerName "Dimensions" :flex 1 :minWidth 90 :disableColumnMenu true})

(defui add-new-column-button [{:keys [columns add-column]}]
  (let [[anchor-el set-anchor-el] (uix/use-state nil)
        channel (ah/use-channel)
        add (fn [field] (fn [] (set-anchor-el nil) (add-column field)))]
    ($ :<>
       ($ Button {:variant "outlined"
                  :size "small"
                  :startIcon ($ Icon "add")
                  :sx #js {:ml 1}
                  :onClick #(set-anchor-el (.-currentTarget %))}
          "Add new column")
       ($ Menu {:anchorEl anchor-el
                :open (boolean anchor-el)
                :onClose #(set-anchor-el nil)}
          (when (not= channel "meta")
            ($ MenuItem {:onClick (add "impression")} "Impression tracker"))
          (for [{:keys [field header]} cols/normal-fixed-columns]
            ($ MenuItem {:key field
                         :disabled (cols/has-column? columns field)
                         :onClick (add field)}
               header))))))

(defui cm360-toggle [{:keys [enabled settings has-placements]}]
  (let [url-context (use-subscribe [:url-context])
        {save-cm360-settings :mutate} (use-mutation (cm360.q/cm360-settings-mutation url-context))
        disable! (fn []
                   (save-cm360-settings (assoc (select-keys settings [:campaign-id :site-id])
                                               :enabled false)))
        on-toggle (fn []
                    (if enabled
                      (if has-placements
                        (rf/dispatch [:modal/open {:id ::cm360-settings/disable-confirmation
                                                   :props {:on-confirm disable!}}])
                        (disable!))
                      (rf/dispatch [:modal/open {:id ::cm360-settings/cm360-settings
                                                 :props {:initial-enabled true}}])))]
    ($ FormControlLabel
       {:label "CM360 tracker"
        :sx #js {".MuiFormControlLabel-label" #js {:ml 1}}
        :control ($ Switch {:checked enabled :onChange on-toggle})})))

(defui csv-toolbar [{:keys [on-download on-file]}]
  (let [file-input-ref (uix/use-ref nil)
        [anchor-el set-anchor-el] (uix/use-state nil)]
    ($ :<>
       ($ :input {:ref file-input-ref
                  :type "file"
                  :accept ".csv"
                  :style #js {:display "none"}
                  :onChange (fn [^js e]
                              (when-let [file (-> e .-target .-files (aget 0))]
                                (on-file file))
                              (set! (.. e -target -value) ""))})
       ($ Button {:variant "text"
                  :color "inherit"
                  :endIcon ($ Icon "keyboard_arrow_down")
                  :onClick #(set-anchor-el (.-currentTarget %))
                  :sx #js {:alignSelf "start"}}
          "CSV")
       ($ Menu {:anchorEl anchor-el
                :open (boolean anchor-el)
                :onClose #(set-anchor-el nil)}
          ($ MenuItem {:onClick (fn [] (set-anchor-el nil) (on-download))}
             ($ Icon {:sx #js {:mr 1}} "download")
             "Download CSV")
          ($ MenuItem {:onClick (fn [] (set-anchor-el nil) (.click @file-input-ref))}
             ($ Icon {:sx #js {:mr 1}} "upload")
             "Upload CSV")))))

(def BulkEditToolbar
  (uix/as-react
   (fn [{:keys [filters cm360 column-controls csv]}]
     ($ dg/grid-toolbar
        ($ Stack {:direction "row"
                  :justifyContent "space-between"
                  :alignItems "center"
                  :sx #js {:width "100%"}}
           ($ filter-menu filters)
           ($ Stack {:direction "row" :spacing 2 :alignItems "center"}
              (when (:available cm360)
                ($ cm360-toggle cm360))
              (if (:enabled cm360)
                ($ Button {:variant "outlined"
                           :size "small"
                           :startIcon ($ Icon "edit")
                           :sx #js {:ml 1}
                           :onClick #(rf/dispatch [:modal/open {:id ::cm360-settings/cm360-settings}])}
                   "Edit CM360 settings")
                ($ add-new-column-button column-controls))
              ($ Divider {:orientation "vertical" :flexItem true})
              ($ csv-toolbar csv)))))))

(defui download-warning [{:keys [on-download on-dismiss]}]
  ($ Alert
     {:severity "warning"
      :icon ($ AlertIcon)
      :onClose on-dismiss
      :action ($ Button {:color "inherit" :size "small" :onClick on-download}
                 "Download Anyway")
      :sx #js {:alignItems "flex-start"}}
     ($ AlertTitle "Before downloading add the required columns")
     "Your CSV will only contain the columns currently visible in the table."
     ($ :br)
     "Add the columns you need (e.g. Impression Tracker, Tagging) via + Add new column."))

(defui footer [{:keys [on-save]}]
  ($ Stack {:direction "row" :spacing 1 :justifyContent "flex-end"}
     ($ Button {:variant "outlined" :onClick #(rf/dispatch [:ocp/close])} "Cancel")
     ($ Button {:variant "contained" :onClick on-save} "Save")))

(defmodal overwrite-warning ::overwrite-warning
  [{:keys [on-save]}]
  ($ modal-v2
     {:icon ($ SvgIcon {:color "warning"} ($ AlertIcon))
      :title "Overwrite Values"
      :footer ($ Stack {:direction "row" :spacing 1}
                 ($ Button {:variant "outlined"
                            :on-click #(rf/dispatch [:modal/close])}
                    "Cancel")
                 ($ Button {:variant "contained"
                            :color "warning"
                            :on-click on-save}
                    "Save"))}
     ($ Typography {:sx #js {:maxWidth 600}}
        "You're about to overwrite existing tracker or tagging values. Please confirm to continue.")))

(defui variant-grid [{{:keys [rows process-row-update]} :row-controls
                      {:keys [columns delete-column] :as column-controls} :column-controls
                      {:keys [show-errors]} :validation
                      :keys [cm360 read-only] :as props}]
  (let [{:keys [filter-rows] :as filters} (use-filters)
        {:keys [csv warning]} (hook/use-csv-actions props)
        value-cols (uix/use-memo #(build-value-columns columns delete-column show-errors read-only)
                                 [columns delete-column show-errors read-only])
        filtered-rows (uix/use-memo #(clj->js (filter-rows (->clj rows))) [rows filter-rows])
        columns-defs (uix/use-memo #(clj->js (into [content-id-column decision-path-column dimensions-column]
                                                   value-cols))
                                   [value-cols])]
    ($ Stack {:spacing 2 :sx #js {:height "100%"}}
       (when (and (not read-only) (:visible warning))
         ($ download-warning warning))
       ($ DataGridPremium
          (cond-> {:columns columns-defs
                   :rows filtered-rows
                   :getRowId #(.-id %)
                   :rowHeight 60
                   :disableRowSelectionOnClick true
                   :hideFooter true
                   :sx #js {"& .MuiDataGrid-columnHeaderTitleContainerContent"
                            #js {:width "100%"}}}
            (not read-only)
            (merge {:processRowUpdate process-row-update
                    :slots #js {:toolbar BulkEditToolbar}
                    :slotProps #js {:toolbar #js {:filters filters
                                                  :cm360 cm360
                                                  :column-controls column-controls
                                                  :csv csv}
                                    :baseTextField dg/grid-toolbar-outlined-input}}))))))

(defocp ocp-view ::ad-variant-table {:width "80%"} [props]
  (let [{:keys [on-save read-only] :as ocp-state} (hook/use-ocp-state props)]
    ($ ocp (cond-> {:title "Ad Variant Table"}
             (not read-only) (assoc :footer ($ footer {:on-save on-save})))
       ($ variant-grid ocp-state))))
